import { Injectable } from '@angular/core';

/**
 * Return the global native browser history object
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
const _history = (): any => history;

@Injectable({
    providedIn: 'root',
})
export class HistoryRef {
    get nativeApi(): any {
        return _history();
    }
}
